// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2udyn","upload":"Small_upload__2Lfmh","imageWrap":"Small_imageWrap__3HDrM","removeBtn":"Small_removeBtn__29ZVQ"};